import React, { useState } from 'react';
import CharacterContainer from './CharacterContainer';
import SelectionContainer from './SelectionContainer';
import { buttons } from './data';
import styles from './OptionContainer.module.scss';


export default function OptionContainer() {

    const [groupID, setGroupID] = useState<string>("1");

    const handleClick = (event: any) => {
        setGroupID(event.currentTarget.id);
    }

    const length = buttons.length; 

    const onArrowUp = () => {
        if (parseInt(groupID) <= 1) {
            setGroupID(length.toString());
        } else {
            setGroupID((parseInt(groupID) - 1).toString());
        }
    }

    const onArrowDown = () => {
        if (parseInt(groupID) >= length) {
            setGroupID("1");
        } else {
            setGroupID((parseInt(groupID) + 1).toString());
        }
    }

    console.log('check id', groupID);

    return (
        <div className={styles["container"]}>
            <div className={styles["selection-container"]}>
                <SelectionContainer handleClick={handleClick} groupID={groupID} onArrowUp={onArrowUp} onArrowDown={onArrowDown} />
            </div>
            <div className={styles["character-container"]}>
                <CharacterContainer groupID={groupID} />
            </div>
        </div>
    )
}